import { render, staticRenderFns } from "./PagePerformanceReviewSettings.vue?vue&type=template&id=f4d85562&scoped=true&"
import script from "./PagePerformanceReviewSettings.vue?vue&type=script&lang=js&"
export * from "./PagePerformanceReviewSettings.vue?vue&type=script&lang=js&"
import style0 from "./PagePerformanceReviewSettings.vue?vue&type=style&index=0&id=f4d85562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d85562",
  null
  
)

export default component.exports